import React from 'react'
import { Autocomplete } from '@core/Components/Autocomplete'
import { searchSuburbStatePostcodes } from '@mobi/account/Common/Address'
import {
  debounceWithReturn,
  DELAY,
} from '@core/Areas/Account/SignUp/Old/IdentityConfirmation/AddressQueries'

const SuburbStatePostcodeAutosuggest = Autocomplete as new () => Autocomplete<string>

const getSuggestionValue = (suggestion: string) => suggestion

export const fetchSuggestedSuburbStatePostCodes = debounceWithReturn(
  (inputValue: string): Promise<string[]> => {
    if (!inputValue || inputValue.length < 4) {
      return Promise.resolve<string[]>([])
    }

    return searchSuburbStatePostcodes(inputValue).then(result => result.map(({ value }) => value))
  },
  DELAY
) as (inputValue: string) => Promise<string[]>

interface SuburbStatePostcodeAutocompleteProps {
  id: string
  inputId?: string
  value?: string | null
  autoFocus?: boolean
  errorMessage: string | boolean
  onSelection(suggestion: string | null): void
  onBlur?(): void
}

export function SuburbStatePostcodeAutocomplete({
  id,
  inputId,
  value = null,
  errorMessage,
  onSelection,
  autoFocus,
  onBlur,
}: SuburbStatePostcodeAutocompleteProps) {
  return (
    <SuburbStatePostcodeAutosuggest
      id={id}
      selection={value}
      inputProps={{ id: inputId, onBlur }}
      errorMessage={errorMessage}
      autoFocus={autoFocus}
      onSelection={onSelection}
      getSuggestionValue={getSuggestionValue}
      getSuggestionsForInputValue={fetchSuggestedSuburbStatePostCodes}
    />
  )
}
